import { useContext } from 'react'
import { SubdomainContext } from './SubdomainContext';

export const useSubdomain = () => useContext(SubdomainContext)